module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.a4d31128b633bc0b1cc1.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/assets/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module id = ../../../../../src/assets/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module chunks = styles